var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isPaid)?_c('v-btn',{attrs:{"loading":_vm.loading,"color":"secondary","block":""},on:{"click":_vm.pay}},[_vm._v("Pay")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }